import * as Sentry from '@sentry/gatsby';
import { sentryConfigBrochureware } from '@agria/utils/src/sentryConfigBrochureware';

Sentry.init(sentryConfigBrochureware);
